import { useLocation, useParams, useNavigate } from "react-router-dom";
import { Paper, Radio } from "@mui/material";

import { Link } from "react-router-dom";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";

import qs from "query-string";
import { capitalCase } from "capital-case";

const menuMap = [
  {
    label: "Tasks",
    value: "tasks",
  },
  {
    label: "Products",
    value: "product",
  },
  {
    label: "Material Library",
    value: "material",
  },
];

const UnionwearLayout = ({ children }) => {
  const location = useLocation();
  const pathname = location?.pathname || "";
  // Use regex to extract the string after "unionwear/"
  const match = pathname.match(/unionwear?\/(.*)/);

  // Extract the matched substring
  let substring = match ? match[1] : "tasks";
  let pathArr = substring.split("/");
  if (pathArr.length > 0) {
    substring = pathArr[0];
  }

  return (
    <SuiBox>
      <SuiBox display="flex" gap={1}>
        <SuiBox minWidth={140} width={140}>
          <Paper>
            <SuiBox display="flex" flexDirection="column" width={"100%"}>
              {menuMap.map((item, index) => (
                <SuiBox component={Link} to={`/unionwear${item?.value ? "/" + item?.value : ""}`}>
                  <SuiBox
                    className={
                      substring == item.value
                        ? "model-function-button-active"
                        : "model-function-button-inactive"
                    }
                    sx={{
                      textAlign: "center",
                      width: "100%",
                      height: "100%",
                      margin: "auto",
                      lineHeight: 1.2,
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#f3f3f3",
                      },
                    }}
                  >
                    <SuiBox
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 13,
                      }}
                      py={1}
                      px={2}
                    >
                      {item.label}
                    </SuiBox>
                  </SuiBox>
                </SuiBox>
              ))}
            </SuiBox>
          </Paper>
        </SuiBox>
        <SuiBox flexGrow={1}>
          <Paper>{children}</Paper>
        </SuiBox>
      </SuiBox>
    </SuiBox>
  );
};

export default UnionwearLayout;
